module.exports = __webpack_public_path__ + "media/images/steps/svg/promotion-165362085d418dcbc0f2ff894e7b2602.svg";